import styled from '../../config/theme'

const Container = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  height: 100%;
`

const Actions = styled.div`
  display: flex;

  > * {
    margin: 0 5px;
  }
`

export {
  Container,
  Actions,
}
